import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize, map} from 'rxjs/operators';
import {LoaderService} from '../modules/shared/components/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    constructor(public loaderService: LoaderService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let blocking = true;

        if (req.params.get('doNotShowLoader')) {
            blocking = false;
        }
        const isApiReq = req.url.startsWith('/evo/api') || req.url.startsWith('/evo/auth');
        const loaderEnabled = blocking && isApiReq;

        let blockHidden = false;
        if (loaderEnabled) {
            this.loaderService.show();
        }

        return next.handle(req).pipe(
            map((event) => {
                if (event instanceof HttpResponse && loaderEnabled) {
                    this.loaderService.hide();
                    blockHidden = true;
                }
                return event;
            }),
            catchError((error: any) => {
                if (error instanceof HttpErrorResponse) {
                    if (loaderEnabled) {
                        this.loaderService.hide();
                        blockHidden = true;
                    }
                }
                return throwError(error);
            }),
            finalize(() => {
                if (loaderEnabled && !blockHidden && this.loaderService.isLoading.value) {
                    this.loaderService.hide();
                }
            })
        );
    }
}
